import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  PerplayLogApi,
  LogControllerDtoNftTransactionLogListRequest
} from '../../models/src';
import {
  nftTransactionLogList,
  setNFTTransactionLogPagination,
  setTotalCount
} from '../../actions/log/nftTransactionLogActions';
import { NFT_TRANSACTIONLOG_LIST_REQUEST } from '../../constants/log/nftTransactionLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoNftTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoNftTransactionLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* nftTransactionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoNftTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.tokenType = payload.tokenType;
    requestData.targetAccount = payload.targetAccount;
    requestData.transactionType = payload.transactionType;
    requestData.nftUid = payload.nftUid;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogNftTransactionLogListPost({ logControllerDtoNftTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoNftTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(nftTransactionLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setNFTTransactionLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftTransactionLogRootSaga() {
  yield all([
    takeEvery(NFT_TRANSACTIONLOG_LIST_REQUEST, nftTransactionLogListRequestSaga),
  ])
}

const nftTransactionLogSagas = [
  fork(nftTransactionLogRootSaga),
];

export default nftTransactionLogSagas;
